<template>
  <div>
		<v-card-text class="pa-0" style="height: 500px; overflow-y: auto;">
			<v-layout class="pa-2" row wrap style="height: auto;" v-if="account && is_edit">
				<v-flex xs6 style="padding-bottom: 5px;" pr-1>
          <v-text-field v-model="account.email" label="Email" readonly></v-text-field>

          <password v-model="account.passwords" label="New password" confirm-label="Confirm new password" size="12" :generate-icon="true"></password>
        </v-flex>
        <v-flex xs6 style="padding-bottom: 5px;" pr-1>
          <v-text-field v-model="account.own_password" label="Your password" type="password" autocomplete="current-password"></v-text-field>
        </v-flex>
      </v-layout>
  	</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
  		<v-btn flat @click="reset">Reset</v-btn>
  		<v-btn v-if="is_edit" color="success" @click="save(false)">Save</v-btn>
  		<v-btn v-if="is_edit" color="success" @click="save(true)">Save and close</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import Password from '../Password'
export default {
  props: ['id'],
  components: {
    Password
  },
  data () {
    var ch = this.$cloudserver.channel("accounts:"+(this.id||"create"));
    return {
      ws_channel: ch,
      account: this.convertAccount(ch.data)
    }
  },
  watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				if(typeof(newVal) != "undefined") {
					this.account = this.convertAccount(newVal, oldVal);
				}
			},
			deep: true
		},
		'$route' (to, from) {
			if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
				this.ws_channel = this.$cloudserver.channel("accounts:"+(this.id||"create"));
				this.ws_channel.join();
			}
		}
	},
  created() {
    this.ws_channel.join();
  },
  computed: {
    is_edit () {
      return typeof(this.account) != "undefined" && this.account.id != null;
    }
  },
  methods: {
    reset () {
      this.account = this.convertAccount(this.ws_channel.data);
    },
    clear_passwords(obj) {
      obj.passwords = {
        password: "",
        confirm: ""
      }
      obj.password = "";
      obj.password_confirm = "";
      obj.own_password = "";
    },
    save (close) {
      this.account.password = this.account.passwords.password;
      this.account.password_confirm = this.account.passwords.confirm;
      if (this.account.password.length < 6) {
        this.$message.warning("Password too short!");
        this.clear_passwords(this.account);
        return;
      }
      if(this.account.password != this.account.password_confirm) {
        this.$message.warning("Passwords dont't match!");
        this.clear_passwords(this.account);
        return;
      }
      if(typeof(this.ws_channel) != "undefined") {
        var self = this;

        var account = _.cloneDeep(this.account);
        this.clear_passwords(this.account);

        this.ws_channel.save({account: account})
          .then((msg) => {
            this.clear_passwords(account);
            if (typeof(self.id) == "undefined") {
              self.$message.success("Account was created!");
            } else {
              self.$message.success("Account was updated!");
            }
            if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.id}})
            }
          })
          .catch((msg) => {
            this.clear_passwords(account);
            console.log(msg);
            if (typeof(self.id) == "undefined") {
              self.$message.warning("Unable to create account!");
            } else {
              self.$message.warning("Unable to update account!");
            }
          });
      }
    },
    convertAccount (newVal, oldVal) {
      var account = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }

      if(typeof(account) == "undefined" || _.isEmpty(account)) return undefined;

      this.clear_passwords(account);

      return account;
    }
  }
}
</script>
